// ABOUTME: Custom hook to fetch and manage daily job role counts
// ABOUTME: Provides real-time job count data with fallback to live count

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useJobCount = () => {
  return useQuery({
    queryKey: ['job-count'],
    queryFn: async () => {
      // First try to get today's cached count
      const today = new Date().toISOString().split('T')[0];
      const { data: dailyCount } = await supabase
        .from('daily_job_counts')
        .select('count')
        .eq('date', today)
        .single();

      if (dailyCount?.count !== null && dailyCount?.count !== undefined) {
        return dailyCount.count;
      }

      // Fallback to live count if no cached data
      const { count, error } = await supabase
        .from('job_roles')
        .select('*', { count: 'exact', head: true })
        .eq('is_active', true);

      if (error) {
        throw error;
      }

      return count || 0;
    },
    staleTime: 1000 * 60 * 60, // Consider data fresh for 1 hour
    gcTime: 1000 * 60 * 60 * 24, // Keep in cache for 24 hours
  });
};